<div class="mat-typography mat-body mat-app-background">
  <article class="content-section">
    <ptl-zip-code-and-county-select
      (zipAndCountyChanged)="zipCountyChanged($event)"
      [preloadedValues]="stateValues"
      (submitFormEvent)="gotoURL(submitUrl)"
    ></ptl-zip-code-and-county-select>

    <section class="buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!zipCodeRegion"
        (click)="gotoURL(submitUrl)"
      >
        <span><slot name="submit-zip-county_view-plans">Submit</slot></span>
      </button>
    </section>
  </article>
</div>
